// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BotUsageFooter — bottom of the sidebar: AI-response usage + upgrade. */

.bot-usage-footer {
  width: 100%;
  margin: 0 auto  4px auto;
  padding: 12px;
  box-sizing: border-box;
  border-radius: 10px;
  /* Same resting surface as the header selector chips (bg 0.07 / border 0.16). */
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.16);
  color: #ffffff;
}

.bot-usage-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.bot-usage-label {
  font-size: 12px;
  font-weight: 600;
  /* Match the header selector font colour exactly (#ffffff). */
  color: #ffffff;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.bot-usage-plan {
  font-size: 11px;
  font-weight: 600;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.18);
  border-radius: 999px;
  padding: 2px 8px;
  white-space: nowrap;
}

.bot-usage-count {
  margin-top: 6px;
  font-size: 14px;
  font-weight: 700;
  color: #ffffff;
}

.bot-usage-extra {
  margin-left: 8px;
  font-size: 11px;
  font-weight: 700;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.18);
  border-radius: 999px;
  padding: 2px 8px;
  white-space: nowrap;
}

.bot-usage-ending {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  font-size: 11px;
  font-weight: 700;
  color: #fcd34d;
  line-height: 1.35;
}
.bot-usage-ending svg { font-size: 11px; flex: 0 0 auto; }

.bot-usage-track {
  margin-top: 8px;
  height: 6px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.2);
  overflow: hidden;
}

.bot-usage-fill {
  height: 100%;
  border-radius: 999px;
  background: #ffffff;
  transition: width 0.3s ease;
}

.bot-usage-fill.full {
  background: #ff6b6b;
}

.bot-usage-upgrade {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  margin-top: 12px;
  padding: 9px 12px;
  border: none;
  border-radius: 8px;
  background: #fff;
  color: #5616ea;
  font-size: 13px;
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.bot-usage-upgrade:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
}

/* The LinkedIn bonus while the account has not claimed it: gold, like the claim in the bonus modal */
.bot-usage-bonus {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  margin-top: 8px;
  padding: 9px 12px;
  border: none;
  border-radius: 8px;
  background: linear-gradient(135deg, #ffdc73 0%, #ffbf2e 100%);
  color: #2b1700;
  font-size: 13px;
  font-weight: 700;
  font-family: inherit;
  white-space: nowrap;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.bot-usage-bonus:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 14px rgba(240, 160, 0, 0.45);
}
`, "",{"version":3,"sources":["webpack://./src/components/BotUsageFooter.css"],"names":[],"mappings":"AAAA,yEAAyE;;AAEzE;EACE,WAAW;EACX,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,+EAA+E;EAC/E,qCAAqC;EACrC,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6DAA6D;EAC7D,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qCAAqC;EACrC,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qCAAqC;EACrC,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;AACA,wBAAwB,eAAe,EAAE,cAAc,EAAE;;AAEzD;EACE,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,qGAAqG;AACrG;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD","sourcesContent":["/* BotUsageFooter — bottom of the sidebar: AI-response usage + upgrade. */\r\n\r\n.bot-usage-footer {\r\n  width: 100%;\r\n  margin: 0 auto  4px auto;\r\n  padding: 12px;\r\n  box-sizing: border-box;\r\n  border-radius: 10px;\r\n  /* Same resting surface as the header selector chips (bg 0.07 / border 0.16). */\r\n  background: rgba(255, 255, 255, 0.07);\r\n  border: 1px solid rgba(255, 255, 255, 0.16);\r\n  color: #ffffff;\r\n}\r\n\r\n.bot-usage-head {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 8px;\r\n}\r\n\r\n.bot-usage-label {\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  /* Match the header selector font colour exactly (#ffffff). */\r\n  color: #ffffff;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.3px;\r\n}\r\n\r\n.bot-usage-plan {\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  color: #ffffff;\r\n  background: rgba(255, 255, 255, 0.18);\r\n  border-radius: 999px;\r\n  padding: 2px 8px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.bot-usage-count {\r\n  margin-top: 6px;\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n  color: #ffffff;\r\n}\r\n\r\n.bot-usage-extra {\r\n  margin-left: 8px;\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  color: #ffffff;\r\n  background: rgba(255, 255, 255, 0.18);\r\n  border-radius: 999px;\r\n  padding: 2px 8px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.bot-usage-ending {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  margin-top: 8px;\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  color: #fcd34d;\r\n  line-height: 1.35;\r\n}\r\n.bot-usage-ending svg { font-size: 11px; flex: 0 0 auto; }\r\n\r\n.bot-usage-track {\r\n  margin-top: 8px;\r\n  height: 6px;\r\n  border-radius: 999px;\r\n  background: rgba(255, 255, 255, 0.2);\r\n  overflow: hidden;\r\n}\r\n\r\n.bot-usage-fill {\r\n  height: 100%;\r\n  border-radius: 999px;\r\n  background: #ffffff;\r\n  transition: width 0.3s ease;\r\n}\r\n\r\n.bot-usage-fill.full {\r\n  background: #ff6b6b;\r\n}\r\n\r\n.bot-usage-upgrade {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  width: 100%;\r\n  margin-top: 12px;\r\n  padding: 9px 12px;\r\n  border: none;\r\n  border-radius: 8px;\r\n  background: #fff;\r\n  color: #5616ea;\r\n  font-size: 13px;\r\n  font-weight: 700;\r\n  font-family: inherit;\r\n  cursor: pointer;\r\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\r\n}\r\n\r\n.bot-usage-upgrade:hover {\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);\r\n}\r\n\r\n/* The LinkedIn bonus while the account has not claimed it: gold, like the claim in the bonus modal */\r\n.bot-usage-bonus {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  width: 100%;\r\n  margin-top: 8px;\r\n  padding: 9px 12px;\r\n  border: none;\r\n  border-radius: 8px;\r\n  background: linear-gradient(135deg, #ffdc73 0%, #ffbf2e 100%);\r\n  color: #2b1700;\r\n  font-size: 13px;\r\n  font-weight: 700;\r\n  font-family: inherit;\r\n  white-space: nowrap;\r\n  cursor: pointer;\r\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\r\n}\r\n\r\n.bot-usage-bonus:hover {\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 4px 14px rgba(240, 160, 0, 0.45);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
